module.exports = __webpack_public_path__ + "static/media/gps_icon.4ff7da41.svg";